import { Button, Form, Modal } from 'react-bootstrap'
import { useSignUpUserVebinarMutation } from '@/shared/api-rtk/index.js'
import { TOAST_ERROR, TOAST_SUCCESS } from '@/shared/constants/toastTypes.js'

export function VebinarModal({ item, active, handleClose }) {
    const [sendUser] = useSignUpUserVebinarMutation()
    const handleSubmitForm = (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const data = Object.fromEntries(formData)

        //Отправка формы
        sendUser(data)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    handleClose()
                    TOAST_SUCCESS('Вы успешно записались')
                }
            })
            .catch((err) => {
                // console.log(err)
                TOAST_ERROR(err.data)
            })
    }
    return (
        <Modal show={active} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Запись на семинар/вебинар <br /> {item['date1']}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{item.text}</p>
                <Form onSubmit={handleSubmitForm}>
                    <Form.Group
                        className="mb-3"
                        controlId="vebinar.ControlInput4"
                    >
                        <Form.Control
                            name={'seminar_id'}
                            type="hidden"
                            value={item['seminar_id']}
                        />
                    </Form.Group>
                    <Form.Group
                        className="mb-3"
                        controlId="vebinar.ControlInput1"
                    >
                        <Form.Control
                            name={'seminar_name'}
                            type="text"
                            placeholder="ФИО"
                        />
                    </Form.Group>
                    <Form.Group
                        className="mb-3"
                        controlId="vebinar.ControlInput2"
                    >
                        <Form.Control
                            name={'seminar_tele'}
                            type="text"
                            placeholder="Телефон"
                        />
                    </Form.Group>
                    <Form.Group
                        className="mb-3"
                        controlId="vebinar.ControlInput3"
                    >
                        <Form.Control
                            name={'seminar_city'}
                            type="text"
                            placeholder="Город"
                        />
                    </Form.Group>
                    <Button type={'submit'}>Отправить</Button>
                </Form>
            </Modal.Body>
        </Modal>
    )
}
